export default "__VITE_ASSET__3618305d__"